export function validateLocalDomainName(localDomainName) {
  const domainRegex =
    /^(?:\*\.)?([a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

  return domainRegex.test(localDomainName);
}
